module.exports = "<span *ngIf=\"stationType == 'ELECTRIC'\" i18n>{{ 'station.electrical' | translate }}</span>\n<span *ngIf=\"stationType == 'MECHANIC'\" i18n>{{ 'station.mechanical' | translate }}</span>\n<span *ngIf=\"stationType == 'MIXED'\" i18n>{{ 'station.mixed' | translate }}</span>\n<span *ngIf=\"stationType == 'EMPTY'\" i18n>{{ 'station.empty' | translate }}</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/stations/station-type-trans/station-type-trans.component.html
// module id = ./src/app/stations/station-type-trans/station-type-trans.component.html
// module chunks = main